export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7520.0a69af26.jpg";